import getMobileOperatingSystem from './get-mobile-os';

const ua = navigator.userAgent || navigator.vendor || window.opera;

// function returns true if its Android Chrome Browser
export const isAndroidChrome = () => /Android/.test(ua) && /Chrome/.test(ua);

export const isIOS = () => getMobileOperatingSystem() === 'iOS';

export const isChromeIOS = () => /CriOS/.test(ua);

export const isFirefoxIOS = () => /FxiOS/.test(ua);

export const isSafari = () => /Safari/.test(ua);

export const isMobile = () => !!window.matchMedia?.('(pointer: coarse)')?.matches;

// Chrome & FF IOS also have Safari in it, so exclude them explicitly
export const isIOSSafari = () => isIOS() && isSafari() && !isChromeIOS() && !isFirefoxIOS();

// function returns true if its in in-app browser on iOS
export const isIOSInApp = () => {
	if (getMobileOperatingSystem() !== 'iOS') {
		return false;
	}
	const rules = ['WebView', '(iPhone|iPod|iPad)(?!.*Safari/)'];
	const regex = new RegExp(`(${rules.join('|')})`, 'ig');
	return Boolean(ua.match(regex));
};
